import React, { Component } from "react";

import SideDrawer from "./components/SideDrawer/SideDrawer";
import FoodItems from "./components/FoodItems/FoodItems";
import LandingPage from "./components/LandingPage/LandingPage";
import OrderItems from "./components/OrderItems/OrderItems";

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      sectionFilter: null,
      visibleItems: null,
    };

    this.setSectionFilter = this.setSectionFilter.bind(this);
    this.setVisibleItems = this.setVisibleItems.bind(this);
  }

  shouldComponentUpdate(nextProps, nextState) {
    return nextState.sectionFilter !== this.state.sectionFilter;
  }

  setSectionFilter(section) {
    if (section && section !== this.state.sectionFilter) {
      this.setState({ sectionFilter: section });
    }
  }

  setVisibleItems(itemType) {
    this.setState({
      visibleItems: itemType,
    });
  }

  componentDidMount() {
    const params = new URLSearchParams(window.location.search);
    const menu = params.get("menu");
    const layout = params.get("app_layout");
    const theme = params.get("theme") || params.get("app_theme");

    if (menu) {
      localStorage.setItem("menu", menu);
    }

    if (theme) {
      localStorage.setItem("app_theme", theme);
    }

    if (layout) {
      let resolvedLayout = layout;
      const resolvedTheme = theme || localStorage.getItem("app_theme");

      // Support `theme=dark` for Chef House layouts by mapping to *_dark variants
      if (
        resolvedTheme === "dark" &&
        resolvedLayout &&
        resolvedLayout.startsWith("chef_house") &&
        !resolvedLayout.endsWith("_dark")
      ) {
        resolvedLayout = `${resolvedLayout}_dark`;
      }

      localStorage.setItem("app_layout", resolvedLayout);
    } else if (theme === "dark") {
      // If only theme is provided, and current layout is Chef House, upgrade it to the dark variant.
      const currentLayout = localStorage.getItem("app_layout");
      if (
        currentLayout &&
        currentLayout.startsWith("chef_house") &&
        !currentLayout.endsWith("_dark")
      ) {
        localStorage.setItem("app_layout", `${currentLayout}_dark`);
      }
    }
  }

  render() {
    return (
      <div>
        <LandingPage />
        <SideDrawer
          selected={this.setSectionFilter}
          setVisible={this.setVisibleItems}
          visibleItems={this.state.visibleItems}
        />
        {this.state.visibleItems === "food" ? (
          <FoodItems
            filter={this.state.sectionFilter}
            changeFilter={this.setSectionFilter}
          />
        ) : this.state.visibleItems === "order" ? (
          <OrderItems />
        ) : null}
      </div>
    );
  }
}

export default App;
